import React from 'react';
import isEqual from 'lodash.isequal';

import { readCMSValue, getDefault } from 'modules/shared-cms/utils';
import { getNestedReferenceId } from 'modules/shared-cms-advanced/utils';

import { CtaImage } from 'modules/shared-ui/components';
import { LabelTitle, DescriptionContainer, TitleBlocContainer } from 'modules/shared-cms-advanced/components';
import { Showroom } from 'modules/shared-cms-advanced/enhanced-blocs';

import { DressList } from '../../components';

import { CreatorProps } from './creator-type';

import enhancer from './creator-enhancer';

import styles from './creator-page.module.css';

const InnerCreatorPage: React.FC<CreatorProps> = React.memo(
    ({
        link: wrappedLink,
        picture: wrappedPicture,
        mentionLabel,
        // Label Title Props
        title: wrappedTitle,
        titleFontSize: wrappedFontSize,
        titleTextColor: wrappedTextColor,
        models,
        ...rest
    }: CreatorProps) => {
        const {
            tTitle = getDefault(readCMSValue(wrappedTitle), ''),
            tFontSize = readCMSValue(wrappedFontSize),
            tTextColor = readCMSValue(wrappedTextColor),

            // logo
            link = readCMSValue(wrappedLink),
            picture = wrappedPicture,
            wrappedShowroomId = getDefault(getNestedReferenceId(rest.showroom), ''),
        } = {};
        return (
            <React.Fragment>
                <div className={`${styles.root} full-height full-width`}>
                    <div>
                        <TitleBlocContainer {...rest} />
                    </div>
                    <div className={styles.descriptionSection}>
                        <div className={styles.nom}>
                            <LabelTitle fontSize={tFontSize} textColor={tTextColor} title={tTitle} />
                        </div>

                        <div className={styles.description}>
                            <DescriptionContainer {...rest} />
                        </div>
                    </div>

                    <DressList models={models} />

                    <div className={`${styles.ctaImage}`}>
                        <CtaImage link={link} target="blank" picture={picture} />
                    </div>

                    <div className={`${styles.mention}`}>
                        <LabelTitle title={mentionLabel} />
                    </div>

                    {wrappedShowroomId && <Showroom id={wrappedShowroomId} />}
                </div>
            </React.Fragment>
        );
    },
    (prevProps, nextProps) => {
        const test = isEqual(prevProps, nextProps);
        return test;
    },
);

export const CreatorPage = enhancer(InnerCreatorPage);
